import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import ISDBLogo from "../assets/ISDBLogo.svg";
import Login from "../modules/auth/Login";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useHandleRequestWithRefresh } from "../hooks/requestWithRefresh";
import LoaderTemplate from "../components/LoaderTemplate";
import { useRef } from 'react';
import { getCDNUrl } from "../utils/cdnUtils";

const Header = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const { auth, logout, login } = useAuth();
  const {handleRequestWithRefresh, loading} = useHandleRequestWithRefresh();


  // TODO: Remove this after testing and login from use auth and un comment the next line
  const handleShow = () => setShow(true);
  // const handleShow = () => {
  //   const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjEzOCIsImVtYWlsIjoiTU1URVNUN0BpZGJocS5vcmciLCJpYXQiOjE3NDQ5MDgxMDUsImV4cCI6MTc0NDkxMTcwNX0.oVC15gruyH-XMQcR8HuS6gN4bJDCb0gsL4bRFpCIftE"; //response.data.data.access_token;
  //   const refresh_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjUiLCJlbWFpbCI6Ik1NVEVTVDdAaWRiaHEub3JnIiwiaWF0IjoxNzQ1MzIyODkxLCJleHAiOjE3NDUzMjY0OTF9.Z_ee8irvrxOVmfzDQzDX_TrYEVCiSSmTRM59wg0lGRw"; // response.data.data.refresh_token;
  //   const user = {id: "138", organization: null, country: null, title: "Consultant", phone_number: "+9999000", 
  //   email: "MMTEST7@idbhq.org", name: "randa-test1"}; //response.data.data.user;
  //   login({ token, refresh_token, user });
  //   console.log("Logged in successfully");
  //   setTimeout(() => {
  //     navigate("/resources");
  //   }, 0);
  // }
  // useEffect(() => {
  //   if (i18n.language === "ar") {
  //     import("../scss/main-ar.scss");
  //   } else {
  //     import("../scss/main-en.scss");
  //   }
  // }, [i18n.language]);
  // const changeLanguage = (lang) => {
  //   i18n.changeLanguage(lang);
  //   localStorage.setItem("language", lang);
  //   searchParams.set("lang", lang);
  //   setSearchParams(searchParams);
  //   window.location.reload();
  // };

  const [nickname, setNickname] = useState("");
  const divRef = useRef(null);

  const handleClick = () => {
    if (divRef.current.classList.contains('show')) {
      divRef.current.classList.remove('show');
    }
  };

  const handleLogout = () => {
    handleRequestWithRefresh(logout)
    .then(() => {
      navigate("/"); // Redirect to home after logout
    })
    .catch((err) => {
      console.error("Logout failed", err);
    });
  };
  const [showPopup, setShowPopup] = useState(false);
  const handleClosePop = () => setShowPopup(false);
  const goToPage = () => {
    if (auth.token) {
      navigate("/resources/addResourceCenterRequest");
    } else {
      // show popup to login
      setShowPopup(true);
    }
  };

  useEffect(() => {
    // const useName = auth.user?.name.trim().split(" ").slice(0, 2)?.map(word => word[0].toUpperCase()).join("");
    const parts = auth.user?.name.trim().split(/[\s-_]+/);
    if (!parts) return;
    let initials = parts?.slice(0, 2)?.map(part => part[0]?.toUpperCase() || "").join("");
    if (initials.length < 2 && parts[0]?.length > 1) {
      initials += parts[0][1].toUpperCase();
    }

    setNickname(initials);
  }, [auth]);

  return (
    <>
      {/* Start Generic Loader */}
      {loading && <LoaderTemplate />}
      {showPopup && <Modal  show={showPopup}   dialogClassName="modal-xl" onHide={handleClosePop}><Login handleClose={handleClosePop}></Login></Modal>}
      {/* End Generic Loader */}
      <header>
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid custome-wide-screen-container">
            <NavLink className="navbar-brand" to="/">
              <img src={getCDNUrl(ISDBLogo)} alt="IsDB Logo" loading="lazy" width={60} height={60} className="img-reset-dementions" />
            </NavLink>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-Menu"></span>
              <span className="icon-Close_Respons d-none"></span>
            </button>
            <div className="collapse navbar-collapse" ref={divRef}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav w-100 mb-2 mb-lg-0"  onClick={handleClick}>
                <li className="nav-item">

                  <NavLink className="nav-link" aria-current="page" to="/" end>
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/isdbhistory" end>
                  IsDB History in SSC
                  </NavLink>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.isdb.org/reverse-linkage" target="_blank" rel="noopener noreferrer">
                  About Reverse Linkage
                  </a>
                </li>

                <li className="nav-item">
                  
                  <NavLink className="nav-link" to="/resources" end>
                    Resource Centers
                  </NavLink>
                </li>
                
                <li className="nav-item">
                  
                  <NavLink className="nav-link" to="https://isdb.instilled.com/containers/2024608190414460398" style={{ minWidth: "10px" }}>
                  IsDB Online Academy For SSC
                  </NavLink>
                </li>
               
                <li className="nav-item">
                  <div className="nav-link" to="/resources/addResourceCenterRequest" onClick={goToPage} end>
                  Join our network
                  </div>
                </li>
              
             
                {auth.token ? (
                  <>
                    <li className="rightside-navbar ms-lg-auto">
                      <ul>
                      <li className="nav-item user-item dropdown">
                        <a
                          className="username dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="user-name">
                            <span>{ nickname }</span>
                          </div>
                          <div className="user-info">
                            <p className="user-name-item">{ auth.user?.name }</p>
                            <p className="email-item"> {auth.user?.email} </p>
                          </div>
                        </a>
                        <ul className="dropdown-menu">
                          <li>
                          <button onClick={handleLogout}>Logout
                            <i className="icon--1"></i>
                          </button>
                          
                          </li>
                        
                        </ul>
                      </li>
                      </ul>
                
                   
                    </li>
                  </>
                ) : (
                  <>
                    <ul className="rightside-navbar ms-lg-auto">
                      <li className="nav-item">
                        <NavLink
                          className="btn-custom btn btn-outline-primary slide-right-effect me-3"
                          aria-current="page"
                          to="/register"
                          end
                        >
                          Sign Up
                        </NavLink>
                      </li>
                      <li className="nav-item">



                        <NavLink
                          className="btn-custom btn btn-primary slide-right-effect"
                          aria-current="page"

                          end
                          onClick={handleShow} >
                          Log In
                        </NavLink>
                        <Modal
                          show={show}
                          onHide={handleClose}
                          dialogClassName="modal-xl"
                        >
                          <Login handleClose={handleClose}></Login>
                        </Modal>
                      </li>
                     
                    </ul>
                  </>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;